<template>

    <Head title="Gerenciamento de Atividades" />
    <div>
        <div class="flex flex-col lg:flex-row w-full mb-2">
            <div class="lg:w-1/2">
                <h1 class="mb-2 text-xl font-roboto text-primary font-semibold">Relatórios de atividades</h1>
            </div>
            <div class="flex flex-wrap gap-2">
                <button class="font-roboto font-medium btn-invalid uppercase"
                    @click.prevent="openModalInvalidar(retorno)">
                    <span class="hidden lg:block">
                        Invalidar Relatório</span>
                </button>
                <button class="font-roboto font-medium uppercase btn-purple" @click.prevent="openModalEdit({})">
                    <span class="hidden lg:block">
                        Adicionar Campo do Relatório</span>
                </button>
            </div>
        </div>
        <div class="shadow_box rounded-lg p-6">
            <div class="flex flex-wrap">
                <div class="w-full lg:w-3/4">
                    <div class="flex flex-wrap">
                        <div class="w-full grid grid-cols-2">
                            <div class="grid grid-rows-2 grid-flow-col">
                                <div>
                                    <span class="font-bold">Mercado</span>
                                </div>
                                <div>
                                    <tooltip-info :title="retorno.market_networks.name" :content="market_datails" />
                                </div>
                            </div>
                            <div class="grid grid-rows-2 grid-flow-col">
                                <div class="text-base font-bold">Fornecedor</div>
                                <div class="font-norma">{{ retorno.providers.name }}</div>
                            </div>
                            <div class="grid grid-rows-2 grid-flow-col">
                                <div>
                                    <span class="font-bold">Data</span>
                                </div>
                                <div>{{ this.$filters.formatDateTime(retorno.date) }}</div>
                            </div>
                        </div>
                        <div class="w-full lg:w-1/2 mt-8">
                            <div>
                                <span class="font-bold">Gerenciamento de atividades</span>
                            </div>
                        </div>
                    </div>

                    <a :href="linkToDownload" target="_blank"
                        class="block w-36 text-center font-roboto my-4 font-medium uppercase btn-purple">
                        Emitir PDF
                    </a>

                </div>
                <div class="w-full">
                    <div class="flex flex-col">
                        <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
                            <div class="inline-block min-w-full py-2 sm:px-6 lg:px-8">
                                <div class="overflow-hidden">
                                    <table class="min-w-full text-center text-sm font-light">
                                        <thead class="border-b font-medium bg-gray-100">
                                            <tr>
                                                <th scope="col" class="px-6 py-2 text-left w-5">
                                                    <Checkbox name="check_all" value="1"
                                                        class="ml-2 text-sm font-medium text-gray-900 truncate"
                                                        v-model="selecionarTodos" @click.prevent="SelecionarTodos()" />
                                                </th>
                                                <th scope="col" class="py-4 px-6 text-right space-x-4" colspan="7">
                                                    <button
                                                        class="my-1 px-3 py-2 text-xs font-roboto font-medium btn-invalid uppercase"
                                                        @click.prevent="openDeleteMass()">
                                                        <span class="hidden lg:block">Excluir</span>
                                                    </button>
                                                    <button
                                                        class="px-3 py-2 text-xs font-roboto font-medium btn-invalid uppercase"
                                                        @click.prevent="openModalOrientaremMassa()">
                                                        <span class="hidden lg:block">Orientar</span>
                                                    </button>
                                                    <button
                                                        class="px-3 py-2 text-xs font-roboto font-medium btn-aproved uppercase"
                                                        @click.prevent="openModalAprovarMassa()">
                                                        <span class="hidden lg:block">Aprovar</span>
                                                    </button>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-for="activity in retorno.activities">
                                                <tr class="border-b">
                                                    <td class="whitespace-nowrap px-6 py-4 w-5">
                                                        <Checkbox name="atividade_id" :inputId="activity.id"
                                                            :value="activity.id" v-model="relatorioActivities"
                                                            class="ml-2 text-sm font-medium text-gray-900 truncate"
                                                            @click.prevent="validaSelecionarTodos()" />
                                                    </td>
                                                    <td class="whitespace-nowrap px-6 py-4 align-top">
                                                        <div class="pl-3">
                                                            <div class="text-base font-semibold">Status</div>
                                                            <div class="font-normal text-gray-500">{{
                                                                status[activity.status] }}</div>
                                                        </div>
                                                    </td>
                                                    <td class="whitespace-nowrap px-6 py-4 align-top">
                                                        <div class="pl-3">
                                                            <div class="text-base font-semibold">Ruptura</div>
                                                            <div class="font-normal text-gray-500">
                                                                {{ activity.nostock ? 'Sim' : 'Não' }}
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td class="whitespace-nowrap px-6 py-4 align-top">
                                                        <div class="pl-3">
                                                            <div class="text-base font-semibold">Marca</div>
                                                            <div class="font-normal text-gray-500">{{ activity.brandName
                                                                }}
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td class="px-6 py-4 align-top">
                                                        <div class="pl-3 w-15">
                                                            <div class="text-base font-semibold">Produtos</div>
                                                            <div class="font-normal text-gray-500">
                                                                {{ formatProductsName(activity.products) }}
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td class="px-6 py-4 align-top">
                                                        <div>
                                                            <div class="text-base font-semibold">Avaliação</div>
                                                            <div class="flex flex-col gap-1 mt-1">
                                                                <button v-if="activity.evaluation > 0"
                                                                    @click.prevent="openCommentsModal(activity)"
                                                                    class="flex items-center gap-1 hover:opacity-80 transition-opacity cursor-pointer"
                                                                    title="Clique para ver comentários">
                                                                    <font-awesome-icon v-for="star in 5" :key="star"
                                                                        :icon="star <= activity.evaluation ? 'fa-solid fa-star' : 'fa-regular fa-star'"
                                                                        :class="star <= activity.evaluation ? 'text-[#FFC857]' : 'text-gray-300'"
                                                                        class="text-base" />
                                                                </button>
                                                                <div v-else class="flex items-center gap-1">
                                                                    <font-awesome-icon v-for="star in 5" :key="star"
                                                                        icon="fa-regular fa-star"
                                                                        class="text-gray-300 text-base" />
                                                                </div>
                                                                <span
                                                                    v-if="activity.evaluation > 0 && hasComments(activity)"
                                                                    class="text-xs text-gray-500 cursor-pointer hover:underline"
                                                                    @click.prevent="openCommentsModal(activity)">
                                                                    ({{ getCommentsCount(activity) }} comentário{{
                                                                        getCommentsCount(activity) !== 1 ? 's' : '' }})
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td class="px-6 py-4 align-top">
                                                        <div>
                                                            <div class="text-base font-semibold">Data</div>
                                                            <div class="font-normal text-gray-500">
                                                                {{ this.$filters.formatDateTime(activity.date) }}
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td class="whitespace-nowrap px-6 py-4 space-x-3 text-right">
                                                        <div class="flex flex-wrap">
                                                            <button
                                                                class="w-full my-1 px-3 py-2 text-xs font-roboto font-medium btn-delete uppercase"
                                                                @click.prevent="openModalDelete(activity)">
                                                                <span class="hidden lg:block">Excluir</span>
                                                            </button>
                                                            <button
                                                                class="w-full my-1 px-3 py-2 text-xs font-roboto font-medium btn-invalid uppercase"
                                                                @click.prevent="openModalEdit(activity)">
                                                                <span class="hidden lg:block">Editar</span>
                                                            </button>
                                                            <button
                                                                class="w-full my-1 px-3 py-2 text-xs font-roboto font-medium btn-invalid uppercase"
                                                                @click="openModalOrientar(activity)">
                                                                <span class="hidden lg:block">Orientar</span>
                                                            </button>
                                                            <button
                                                                class="w-full my-1 px-3 py-2 text-xs font-roboto font-medium btn-aproved uppercase"
                                                                @click.prevent="openModalAprovar(activity)">
                                                                <span class="hidden lg:block">Aprovar</span>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>

                                                <tr v-if="activity.photo.length">
                                                    <td colspan="8" class="border-b pt-2">
                                                        <Carousel :value="getPhotosFromProduct(activity.photo)"
                                                            :numVisible="1" :numScroll="1" circular>
                                                            <template #item="slotProps">
                                                                <div
                                                                    class="max-h-[300px] flex items-center justify-center">
                                                                    <div v-if="isBroken(slotProps.data)"
                                                                        class="text-gray-500 text-sm italic">
                                                                        Esta imagem foi removida automaticamente por uma
                                                                        regra de limpeza do sistema
                                                                    </div>

                                                                    <Image v-else class="max-h-[300px]"
                                                                        :src="slotProps.data" alt="Foto da atividade"
                                                                        preview @error="onImageError(slotProps.data)"
                                                                        @load="onImageLoad(slotProps.data)" />
                                                                </div>
                                                            </template>
                                                        </Carousel>
                                                    </td>
                                                </tr>

                                                <tr v-if="activity.description">
                                                    <td colspan="6" class="border-b pt-2 pb-4">
                                                        <p class="font-normal text-gray-500">Descrição: {{
                                                            activity.description }}</p>
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <modal-edit :modal-scrollable="true" ref="modalReprovar" url="activity_management/update-status"
        id="modal-regra-visita">
        <template #header="{ item }">
            <div class="text-gray-777 font-roboto uppercase">
                <span>Orientar atividade</span>
            </div>
        </template>

        <template #form="{ item }">
            <div class="text-center w-full">
                <font-awesome-icon icon="fa-trash-can" class="text-red-600 text-2xl" />
                <div class="mt-4 mb-4">Deseja orientar essa atividade(s)?</div>
            </div>
            <textarea-input v-model="item.feedback" :error="item.errors.feedback" class="lg:pr-6 w-full mb-3"
                label="Justificativa" />
        </template>

    </modal-edit>

    <modal-edit :modal-scrollable="true" ref="modalInvalidar" url="activity_management/update-status"
        id="modal-regra-visita">
        <template #header="{ item }">
            <div class="text-gray-777 font-roboto uppercase">
                <span>Invalidar relatório</span>
            </div>
        </template>
        <template #form="{ item }">
            <div class="text-center w-full">
                <font-awesome-icon icon="fa-trash-can" class="text-red-600 text-2xl" />
                <div class="mt-4 mb-4">Deseja invalidar esse relatório?</div>
            </div>
            <textarea-input v-model="item.feedback" :error="item.errors.feedback" class="lg:pr-6 w-full mb-3"
                label="Justificativa" />
        </template>
    </modal-edit>

    <modal-edit :modal-scrollable="true" ref="modalAprovar" url="activity_management/update-status">
        <template #header="{ item }">
            <div class="text-gray-777 font-roboto uppercase">
                <span>Aprovar atividade(s)</span>
            </div>
        </template>
        <template #form="{ item }">
            <div class="text-center w-full">
                <font-awesome-icon icon="fa-list-check" class="text-green-600 text-2xl" />
                <div class="mt-4 mb-4">Deseja aprovar essa(s) atividade(s)?</div>
            </div>
        </template>
    </modal-edit>

    <modal-edit :modal-scrollable="true" ref="modalExcluir" url="activity_management/destroy-activity">
        <template #header="{ item }">
            <div class="text-gray-777 font-roboto uppercase">
                <span>Excluir atividade(s)</span>
            </div>
        </template>
        <template #form="{ item }">
            <div class="text-center w-full">
                <font-awesome-icon icon="fa-trash-can" class="text-red-600 text-2xl" />
                <div class="mt-4 mb-4">Deseja excluir essa atividade?</div>
            </div>
        </template>
    </modal-edit>

    <modal-edit ref="modalEdit" title="Atividade" url="activity_management/store" id="modal-edit">
        <template #form="{ item }">
            <multi-select-input appendTo="#modal-edit" v-model="item.products" :multiple="true"
                :options="productOptionsDisp" :error="item.errors.products" class="lg:pr-6 w-full lg:w-1/2 mt-6"
                label="Produtos" optionLabel="name" required="true" />

            <radiobox v-model="item.nostock" :options="options_sim_nao" class="lg:pr-6 w-1/2 mt-6"
                :error="item.errors.nostock" label="Ruptura" />

            <textarea-input v-model="item.description" :error="item.errors.description" class="lg:pr-6 w-full mb-3"
                label="Texto" />
            <div class="w-full">
                <button class="px-3 py-2 text-xs font-roboto font-medium btn-invalid uppercase"
                    @click.prevent="item.photo.push({})">
                    <span class="hidden lg:block">Adicionar Foto</span>
                </button>
            </div>
            <div class="grid grid-cols-2 md:grid-cols-3 gap-4">
                <div v-for="(photo, index) in item.photo">
                    <div class="overflow-hidden">
                        <photo-input-cropped v-model="item.photo[index]" class="mt-10 w-full" type="file"
                            label="Foto" />
                    </div>
                </div>
            </div>

        </template>
    </modal-edit>

    <Modal size="modal-lg" ref="showModalComments">
        <template #body>
            <div class="flex items-center justify-center w-full px-6 py-4 my-4">
                <div class="flex flex-col flex-1 items-center gap-3">
                    <h2 class="text-3xl font-bold text-gray-900">Avaliações</h2>
                    <div class="flex items-center gap-2">
                        <span class="text-4xl font-bold text-gray-900">{{ selectedActivity?.evaluation || 0 }}.0</span>
                        <div class="flex gap-1">
                            <font-awesome-icon v-for="star in 5" :key="star"
                                :icon="star <= (selectedActivity?.evaluation || 0) ? 'fa-solid fa-star' : 'fa-regular fa-star'"
                                :class="star <= (selectedActivity?.evaluation || 0) ? 'text-[#FFC857]' : 'text-gray-300'"
                                class="text-2xl" />
                        </div>
                    </div>
                </div>
                <button @click="closeCommentsModal" class="text-gray-400 hover:text-gray-600 transition-colors">
                    <font-awesome-icon icon="fa-times" class="text-2xl" />
                </button>
            </div>
            <div v-if="loadingComments" class="flex items-center justify-center py-8">
                <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-100"></div>
            </div>

            <div v-else-if="activityComments && activityComments.length > 0">
                <!-- Container com overflow para cortar o segundo card -->
                <div class="relative mb-8 overflow-hidden px-6">
                    <div class="flex gap-4">
                        <div v-for="(comment, index) in paginatedComments" :key="comment.id" :class="[
                            'bg-gray-50 rounded-lg p-6 flex flex-col flex-shrink-0',
                            index === 0 ? 'w-[480px]' : 'w-[480px] opacity-60'
                        ]">

                            <!-- Header do cartão com avatar e título -->
                            <div class="flex items-start gap-4 mb-4">
                                <div
                                    class="w-16 h-16 rounded-full bg-gray-300 flex items-center justify-center flex-shrink-0">
                                    <font-awesome-icon icon="fa-user" class="text-gray-600 text-2xl" />
                                </div>
                                <div class="flex-1">
                                    <h3 class="font-bold text-lg text-gray-900 mb-1">{{ getCommentTitle(comment) }}</h3>
                                    <p class="text-sm text-gray-600 leading-tight">{{ getCommentSubtitle(comment) }}</p>
                                </div>
                                <div class="flex-shrink-0">
                                    <span class="font-semibold text-gray-900">n° {{ currentPage + index }}</span>
                                </div>
                            </div>

                            <!-- Conteúdo do comentário -->
                            <div class="flex-1 mb-4">
                                <p class="text-gray-700 text-sm leading-relaxed">{{ comment.message }}</p>
                            </div>

                            <!-- Footer com data e avaliação -->
                            <div class="flex items-center justify-between pt-4 mt-auto">
                                <span class="text-sm text-gray-500">
                                    Data: {{ formatCommentDate(comment.created_at) }}
                                </span>
                                <div class="flex items-center gap-1">
                                    <span class="mr-2 font-bold text-lg text-gray-900">{{ selectedActivity?.evaluation
                                        || 0
                                    }}.0</span>
                                    <font-awesome-icon v-for="star in 5" :key="star"
                                        :icon="star <= (selectedActivity?.evaluation || 0) ? 'fa-solid fa-star' : 'fa-regular fa-star'"
                                        :class="star <= (selectedActivity?.evaluation || 0) ? 'text-[#FFC857]' : 'text-gray-300'"
                                        class="text-lg" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Paginação -->
                <div v-if="totalPages > 1" class="flex items-center justify-center gap-6 pb-4">
                    <button @click="previousPage" :disabled="currentPage === 1"
                        class="p-2 hover:bg-gray-100 rounded disabled:opacity-30 disabled:cursor-not-allowed">
                        <font-awesome-icon icon="fa-chevron-left" class="text-gray-600 text-lg" />
                    </button>
                    <span class="text-gray-900 font-medium text-lg">{{ currentPage }} / {{ totalPages }}</span>
                    <button @click="nextPage" :disabled="currentPage === totalPages"
                        class="p-2 hover:bg-gray-100 rounded disabled:opacity-30 disabled:cursor-not-allowed">
                        <font-awesome-icon icon="fa-chevron-right" class="text-gray-600 text-lg" />
                    </button>
                </div>
            </div>

            <div v-else class="text-center py-12 text-gray-500">
                <font-awesome-icon icon="fa-comment-slash" class="text-5xl mb-4 text-gray-300" />
                <p class="text-lg">Nenhum comentário registrado para esta atividade.</p>
            </div>
        </template>
    </Modal>
</template>

<script>
import { computed } from 'vue';
import { Head, usePage, Link } from '@inertiajs/inertia-vue3'
import axios from 'axios'
import Layout from '@/Shared/Layout'
import TooltipInfo from '@/Shared/TooltipInfo'
import Checkbox from '@/Shared/PrimeVue/Form/Checkbox'
import TextareaInput from '@/Shared/TextareaInput.vue'
import PhotoInputCropped from '@/Shared/PhotoInputCropped.vue'
import Radiobox from '@/Shared/RadioInput.vue'
import ModalEdit from '@/Shared/ModalEdit'
import Modal from '@/Shared/Modal'
import MultiSelectInput from '@/Shared/MultiSelectInput'
import Image from 'primevue/image';
import Carousel from 'primevue/carousel';

export default {
    components: {
        Head,
        TooltipInfo,
        Checkbox,
        Modal,
        TextareaInput,
        ModalEdit,
        MultiSelectInput,
        PhotoInputCropped,
        Radiobox,
        Image,
        Carousel,
        Link,
    },
    props: {
        retorno: Object,
        status: Object,
        productOptions: Array,
    },
    data() {
        return {
            selecionarTodos: [],
            relatorioActivities: [],
            activities: this.retorno.activities,
            productOptionsDisp: [],
            brokenImages: new Set(),
            options_sim_nao: [
                {
                    label: 'Não',
                    value: 0,
                    name: 'no_stock'
                },
                {
                    label: 'Sim',
                    value: 1,
                    name: 'no_stock'
                }
            ],
            selectedActivity: null,
            activityComments: [],
            loadingComments: false,
            currentPage: 1,
            commentsPerPage: 1, // Paginação de 1 em 1
        }
    },

    computed: {
        paginatedComments() {
            if (!this.activityComments || this.activityComments.length === 0) {
                return [];
            }
            const start = (this.currentPage - 1) * this.commentsPerPage;
            // Mostra o comentário atual + preview do próximo
            const end = start + 2;
            return this.activityComments.slice(start, end);
        },

        totalPages() {
            if (!this.activityComments || this.activityComments.length === 0) {
                return 0;
            }
            // Total de páginas = total de comentários (1 por página)
            return this.activityComments.length;
        },
        linkToDownload() {
            return window.location.href + '/pdf'
        },

        market_datails() {
            const datails = this.$props.retorno?.market_details

            return {
                unidade: datails?.unit,
                endereço: datails?.fulladdress
            }
        }
    },

    layout: Layout,
    methods: {
        isBroken(url) {
            return this.brokenImages.has(url) || !url
        },

        onImageError(url) {
            if (url) this.brokenImages.add(url)
        },

        onImageLoad(url) {
            if (!url) return
            if (this.brokenImages.has(url)) {
                this.brokenImages.delete(url)
            }
        },

        SelecionarTodos() {
            if (this.selecionarTodos.length == 1)
                this.relatorioActivities = this.$props.retorno?.activities.map(activite => activite.id)

            else
                this.RemoveSelecionados();
        },

        formatProductsName(products) {
            return products.map(product => product.name).join(', ')
        },

        getPhotosFromProduct(photos) {
            return photos.map(photo => photo.url)
        },

        RemoveSelecionados() {
            this.relatorioActivities = [];
            this.selecionarTodos = [];
        },

        validaSelecionarTodos() {
            this.selecionarTodos = [];
            if (this.relatorioActivities.length == this.activities.length) {
                this.selecionarTodos.push('1');
            }
        },
        openModalOrientaremMassa() {
            if (!this.relatorioActivities.length) {
                this.$toast.warning('Selecione pelo menos uma atividade');
                return
            }

            this.$refs.modalReprovar.openModalEdit({
                reportId: this.$props.retorno?.id,
                activityId: this.relatorioActivities,
                type: 'activity',
                feedback: '',
                status: 1,
                errors: {}
            });
        },
        openModalInvalidar(item) {
            this.$refs.modalReprovar.openModalEdit({
                type: 'report',
                feedback: item.feedback,
                status: 2,
                reportId: this.$props.retorno?.id,
                errors: {}
            });
        },
        openModalOrientar(item) {
            this.$refs.modalReprovar.openModalEdit({
                reportId: this.$props.retorno?.id,
                activityId: item.id,
                type: 'activity',
                feedback: item.feedback,
                status: 1,
                errors: {}
            });
        },
        openModalEdit(item) {
            this.productOptionsDisp = this.productOptions;
            const produtoSelecionados = [];

            if (typeof (item.products) === 'object') {
                for (const value of Object.values(item.products)) {
                    produtoSelecionados.push(value.id);
                }
            }

            this.$refs.modalEdit.openModalEdit({
                activity: item.id,
                market: this.retorno.market,
                marketNetwork: this.retorno.market_networks.id,
                report: this.retorno.id,
                provider: this.retorno.provider,
                salesPromoter: this.retorno.sales_promoter,
                products: produtoSelecionados,
                description: item.description,
                nostock: item.nostock,
                photo: item.photo ?? [],
                errors: {}
            });
        },
        openModalDelete(item) {
            this.$refs.modalExcluir.openModalEdit({
                reportId: this.$props.retorno?.id,
                activityId: item.id,
                type: 'activity',
                status: 3,
                errors: {}
            });
        },

        openDeleteMass() {
            const activityId = this.relatorioActivities

            if (!activityId.length) {
                this.$toast.warning('Selecione pelo menos uma atividade');
                return
            }

            this.$refs.modalExcluir.openModalEdit({
                reportId: this.$props.retorno?.id,
                activityId,
            })
        },

        openModalAprovar(item) {
            this.$refs.modalAprovar.openModalEdit({
                reportId: this.$props.retorno?.id,
                activityId: item.id,
                type: 'activity',
                status: 3,
                errors: {}
            });
        },
        openModalAprovarMassa() {
            if (!this.relatorioActivities.length) {
                this.$toast.warning('Selecione pelo menos uma atividade');
                return
            }

            this.$refs.modalAprovar.openModalEdit({
                reportId: this.$props.retorno?.id,
                activityId: this.relatorioActivities,
                type: 'activity',
                status: 3,
                errors: {}
            });
        },

        hasComments(activity) {
            // Verifica se a atividade possui comentários carregados
            if (!activity) return false;

            // Verifica diferentes formatos possíveis
            if (activity.comments && Array.isArray(activity.comments) && activity.comments.length > 0) {
                return true;
            }

            if (activity.comments_count && activity.comments_count > 0) {
                return true;
            }

            return false;
        },

        getCommentsCount(activity) {
            if (!activity) return 0;

            if (activity.comments && Array.isArray(activity.comments)) {
                return activity.comments.length;
            }

            if (activity.comments_count) {
                return activity.comments_count;
            }

            return 0;
        },

        async openCommentsModal(activity) {
            // Enriquece a atividade com dados do relatório
            this.selectedActivity = {
                ...activity,
                marketNetworkName: this.retorno.market_networks?.name,
                providerName: this.retorno.providers?.name,
            };

            this.loadingComments = true;
            this.currentPage = 1;

            if (this.$refs.showModalComments) {
                this.$refs.showModalComments.open();
            } else {
                return;
            }

            try {
                const response = await axios.get(`/activity_management/activity/${activity.id}/comments`);
                this.activityComments = response.data.comments || [];

                if (this.activityComments.length === 0 && !activity.evaluation) {
                    this.$toast.info('Nenhum comentário ou avaliação registrado');
                }
            } catch (error) {
                this.$toast.error('Erro ao carregar comentários');
                this.activityComments = [];
            } finally {
                this.loadingComments = false;
            }
        },

        closeCommentsModal() {
            this.$refs.showModalComments.close();
            this.selectedActivity = null;
            this.activityComments = [];
            this.currentPage = 1;
        },

        formatCommentDate(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            return date.toLocaleDateString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        },

        getCommentTitle(comment) {
            // Retorna o nome da rede de mercado (ex: Fort Atacadista, Carrefour)
            if (this.selectedActivity?.marketNetworkName) {
                return this.selectedActivity.marketNetworkName;
            }
            if (this.retorno?.market_networks?.name) {
                return this.retorno.market_networks.name;
            }
            return 'Rede';
        },

        getCommentSubtitle(comment) {
            // Retorna os produtos formatados
            if (this.selectedActivity?.products && Array.isArray(this.selectedActivity.products)) {
                const productNames = this.selectedActivity.products
                    .map(p => p.name || p)
                    .join(', ');
                return productNames;
            }

            if (this.selectedActivity?.products) {
                return this.formatProductsName(this.selectedActivity.products);
            }

            return 'Produtos';
        },

        previousPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
            }
        },

        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
            }
        },
    },

    setup() {
        const user = computed(() => usePage().props.value.auth.user)
        return { user }
    },
}
</script>
